import { CALL_API } from "../middleware";
import { InvestorAllocationBody } from "../types/investorProfile";
import { SET_APPLICANT_ID, SET_APPLICATION_ID, SET_APPLICATION_TYPE, SET_FAMILY_DETAILS, SET_INTERFACE_CODE, SET_INVESTOR_CLIENTID, SET_IS_PORTFOLIO_AVAILABLE, SET_IWAPP_RMID, SET_PAN_NUMBER } from "../types/onBoarding";

export interface IwappRmId {
    iwappRmId: string;
}

interface InvestorClientId {
    investorClientId: string;
}

interface InvApplicantId {
    applicantId: string | number;
}
interface ApplicationType {
    applicationType: string;
    investorName: string
    status: string
    onboardingType: string | number;
}

interface ApplicationId {
    applicationId: string | number;
}

export const storeIwappId =
    (body: IwappRmId) => {
        return {
            type: SET_IWAPP_RMID,
            iwappRmId: body.iwappRmId,
        };
    };

export const storeInvestorClientId = (body: InvestorClientId) => {
    return {
        type: SET_INVESTOR_CLIENTID,
        investorClientId: body.investorClientId
    };
}

export const storeInvApplicantId = (body: InvApplicantId) => {
    return {
        type: SET_APPLICANT_ID,
        applicantId: body.applicantId
    };
}

export const storeApplicationType = (body: ApplicationType) => {
    return {
        type: SET_APPLICATION_TYPE,
        applicationType: body.applicationType,
        investorName: body.investorName,
        status: body.status,
        onboardingType: body.onboardingType
    };
}

export const storeInterfaceCode = (body: string | null) => {
    return {
        type: SET_INTERFACE_CODE,
        clientInterfaceCode: body
    };
}

export const storeApplicationId = (body: ApplicationId) => {
    return {
        type: SET_APPLICATION_ID,
        applicationId: body.applicationId,
    };
}

export const setFamilyDetails =
    ({
        familyId,
        familyName,
        isFamilyHead
    }: {
        familyId: string;
        familyName: string;
        isFamilyHead: string;
    }): { type: string; body: Record<string, string> } => {
        return {
            type: SET_FAMILY_DETAILS,
            body: {
                familyId,
                familyName,
                isFamilyHead
            }
        };
    };

export const setPanNumber = (panNo: string): { type: string; panNo: string; } => {
    return {
        type: SET_PAN_NUMBER,
        panNo
    };
};

export const storeIsPortfolioAvailable = (isPortfolioAvailable: boolean): { type: string; isPortfolioAvailable: boolean } => {
    return {
        type: SET_IS_PORTFOLIO_AVAILABLE,
        isPortfolioAvailable,
    };
}